<ng-template #template>
  <label [style]="item.style" [class]="item.className" (mouseover)="model.onItemMouseIn(item)" (mouseout)="model.onItemMouseOut(item)" (mousedown)="model.onMouseDown()" [title]="item.text">
    <input type="radio"
      class="sv-visuallyhidden"
      [attr.name]="model.questionName" [attr.id]="model.getInputId(index)" [value]="item.value" [attr.aria-label]="model.ariaLabel"
      [disabled]="model.isDisabledAttr" [readonly]="model.isReadOnlyAttr" [checked]="model.value === item.value" (click)="onClick($event)"
      />
      <svg [iconName]="model.getItemSmileyIconName(item)" [size]="'auto'" sv-ng-svg-icon></svg>
  </label>
</ng-template>